import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PerformanceComponent } from './performance/performance.component';

const routes: Routes = [
 
  /*{ path: '', component: PerformanceComponent },

  { 
    path: 'dashboard', 
    children: [
      {
        path: 'performance',
        component: PerformanceComponent,
        data: {breadcrumb: 'performance'},
      }
    ]
  },*/

  { path: '', redirectTo: '/dashboard/performance', pathMatch: 'full' },
  {
    path: 'performance',
    component: PerformanceComponent,
    data: {breadcrumb: 'performance'},
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }